﻿
import { RemoteTriggerHandler } from "./remotetriggerhandler";
import { FileDropRemoteHandler } from "./filedropremotehandler";
import { FileUploadFormRemoteHandler } from "./fileuploadformremotehandler";
import { SwitchRemoteHandler } from "./switchremotehandler";
import { EditorTableFieldChangeRemoteHandler } from "./editortablefieldchangeremotehandler";
import { SingleInputRemoteHandler } from "./singleinputremotehandler";
import { FormInputRemoteHandler } from "./forminputremotehandler";
import { SelectRemoteHandler } from "./selectremotehandler";
import { NestedAnchorRemoteHandler } from "./nestedanchorremotehandler";
import { DefaultRemoteHandler } from "./defaultremotehandler";
import { IRemoteHandler } from "./remote";

export class HandlerFactory {
  create(): Array<IRemoteHandler> {
    return [
      new RemoteTriggerHandler(),
      new FileDropRemoteHandler(),
      new FileUploadFormRemoteHandler(),
      new SwitchRemoteHandler(),
      new EditorTableFieldChangeRemoteHandler(),
      new SingleInputRemoteHandler(),
      new FormInputRemoteHandler(),
      new SelectRemoteHandler(),
      new NestedAnchorRemoteHandler(),
      new DefaultRemoteHandler()
    ];
  }
}